module.exports = __webpack_public_path__ + "img/aura.b6c2024b.png";